import { observer } from 'mobx-react';
import { ReactNode } from 'react';

import { useStore } from '@common/components/StoreProvider';

interface ServiceRouterProps {
	// @TODO: From store.services
	lyceum?: ReactNode;
	academy?: ReactNode;
	international?: ReactNode;
	learningCenter?: ReactNode;
	talented?: ReactNode;
	careerGidance?: ReactNode;
	children?: ReactNode; // Used as default node
}

type TServiceKey =
	| 'lyceum'
	| 'academy'
	| 'international'
	| 'learningCenter'
	| 'talented'
	| 'careerGidance';

export const SERVICES_KEYS: Record<1 | 2 | 3 | 4 | 5 | 6, TServiceKey> = {
	// @TODO: Service.service_key
	1: 'academy',
	2: 'lyceum',
	3: 'international',
	4: 'learningCenter',
	5: 'talented',
	6: 'careerGidance',
};

export enum ServicesIds {
	ACADEMY = 1,
	LYCEUM = 2,
	INTERNATIONAL = 3,
	LEARNING_CENTER = 4,
	TALENTED = 5,
	CAREER_GIDANCE = 6,
}

export function useServiceRouter() {
	const store = useStore();
	const serviceKey: TServiceKey =
		SERVICES_KEYS[store.services.current?.id as 1 | 2 | 3 | 4 | 5 | 6];
	return {
		checkService: (serviceKeyForCheck: TServiceKey) => serviceKeyForCheck === serviceKey,
	};
}

function ServiceRouter({ children, ...props }: ServiceRouterProps) {
	const store = useStore();
	const serviceKey: TServiceKey =
		SERVICES_KEYS[store.services.current?.id as 1 | 2 | 3 | 4 | 5 | 6];
	const node: JSX.Element | null = (
		typeof props[serviceKey] !== 'undefined' ? props[serviceKey] : children
	) as JSX.Element | null;
	return node || null;
}

export default observer(ServiceRouter);
